import { Component, h, Host } from '@stencil/core';
export interface AhaCommentReply extends HTMLAhaCommentReplyElement {}

@Component({
  tag: 'aha-comment-reply',
  styleUrl: 'aha-comment-reply.css',
  shadow: true,
})
export class AhaCommentReply {
  render() {
    return (
      <Host>
        <div class={'aha-comment-reply'}>
          <div class={'aha-comment-reply__avatar-container'}>
            <div class="line" />
            <slot name="avatar"></slot>
          </div>
          <slot name="body"></slot>
        </div>
      </Host>
    );
  }
}
